import WarrantySettingForm from "./warrantySettingForm.container";

export default WarrantySettingForm;
